import { Box, Skeleton, UnorderedList, ListItem } from '@chakra-ui/react';
import { FC } from 'react';

import { useResources } from '@/lib/datx-jsonapi-react';
import { queryLectures } from '@/queries/thin-lectures';

export interface ISessionTooltipLecturesListProps {
  sessionId: string;
}

export const SessionTooltipLecturesList: FC<ISessionTooltipLecturesListProps> = ({ sessionId }) => {
  const { data: lectures } = useResources(queryLectures(sessionId));

  if (!lectures) {
    return (
      <Box>
        <UnorderedList>
          <ListItem my={3}>
            <Skeleton w="100%" h="24px" bg="gray.200" />
          </ListItem>
          <ListItem>
            <Skeleton w="100%" h="24px" bg="gray.200" />
          </ListItem>
        </UnorderedList>
      </Box>
    );
  }

  return (
    <Box>
      <UnorderedList>
        {lectures.map(({ id, title: lectureTitle }) => (
          <ListItem key={id}>{lectureTitle}</ListItem>
        ))}
      </UnorderedList>
    </Box>
  );
};
